<template>
  <v-dialog v-model="dialog" max-width="750px" class="rounded-xl">
    <template v-slot:activator="{ on, attrs }">
      <v-btn elevation="0" color="primary" v-bind="attrs" v-on="on">
        <v-icon left>mdi-plus-circle</v-icon>
        {{ $t("story.create.createAStory") }}
      </v-btn>
    </template>
    <v-card color="accentElementBackground" class="pa-10 rounded-xl">
      <v-btn
        absolute
        class="rounded-lg pa-1"
        min-width="0"
        small
        right
        elevation="0"
        top
        @click="dialog = false"
        color="accentElement"
        ><v-icon color="white">mdi-close</v-icon></v-btn
      >
      <v-card-text>
        <v-container class="text-left">
          <v-row class="text-center">
            <v-col>
              <h1>{{ $t("story.create.createANewStory") }}</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pl-0" cols="11"
              ><h2>
                {{ $t("story.create.keepingItBriefWhatsYourStoryAbout?") }}
              </h2></v-col
            >
            <v-col cols="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on"
                    >mdi-help-circle-outline</v-icon
                  >
                </template>
                <span>
                  {{ $t("story.create.aShortDescriptionYouCanEdit") }}
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <Tagline hideLabel v-model="summary" />
            </v-col>
          </v-row>
          <ApolloMutation
            :mutation="(gql) => createStoryQuery"
            :variables="{
              summary: summary,
            }"
            :refetchQueries="refetchQueries"
            @done="onDone"
          >
            <template v-slot="{ mutate, loading, error }">
              <v-row class="text-center">
                <v-col>
                  <v-btn
                    :loading="loading"
                    @click="
                      mutate({
                        refetchQueries: ['GetMyStories'],
                      })
                    "
                    :disabled="!buttonActive"
                    color="primary"
                    elevation="0"
                    >{{ $t("story.create.createYourStory") }}</v-btn
                  >
                </v-col>
              </v-row>
              <v-row v-if="error">
                <v-col>
                  {{ error }}
                </v-col>
              </v-row>
            </template>
          </ApolloMutation>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Tagline from "@/components/CreatorTools/StoryHub/BasicInfo/Tagline";
import StoryMutations from "@/graphql/StoryMutations";
export default {
  components: {
    Tagline,
  },
  data() {
    return {
      dialog: false,
      summary: "",
      storyId: null,
      cacheUpdated: false,
    };
  },
  computed: {
    createStoryQuery() {
      return StoryMutations.createStory;
    },
    getMyStoriesQuery() {
      return StoryMutations.getMyStories;
    },
    buttonActive() {
      return this.summary && this.summary != "" ? true : false;
    },
  },
  methods: {
    refetchQueries() {
      return [
        {
          query: StoryMutations.getMyStories,
        },
      ];
    },
    onDone(response) {
      this.storyId = response.data.createStory.story._id;
      this.dialog = false;

      this.$router.push("/storyHub/" + this.storyId + "/basic-info");
    },
  },
};
</script>